import EpiContext from '@episerver/spa-core/Spa';
import { getReportParams, report } from '../../../middleware/report';

function getLoginLevel() {
  const loginData = EpiContext.getStore()?.getState()?.authentication?.loginData;
  if (loginData?.isFullAuthenticated) return 'זיהוי מלא';
  if (loginData?.isOtpExtendedAuthenticated) return 'OTP מורחב';
  if (loginData?.isOtpAuthenticated) return 'OTP';
  return '';
}

export function dwhEnterUpdatePayment(business) {
  let channel = business ? 'WebsiteBusiness' : 'WebsitePrivate';
  let reportParams = {};
  reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Update Payment Method';
  reportParams.channel = channel;
  reportParams.actionType = 'Enter Update Payment';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Enter Update Payment';
  report(reportParams);
}

export function dwhSelectPaymentMethod(business) {
  let channel = business ? 'WebsiteBusiness' : 'WebsitePrivate';
  let reportParams = {};
  reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Update Payment Method';
  reportParams.channel = channel;
  reportParams.actionType = 'Select Payment method for update';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Select Payment method for update';
  report(reportParams);
}

export function dwhAccountsForUpdate(business) {
  let channel = business ? 'WebsiteBusiness' : 'WebsitePrivate';
  let reportParams = {};
  reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Update Payment Method';
  reportParams.channel = channel;
  reportParams.actionType = 'Select accounts for update';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Select accounts for update';
  report(reportParams);
}

export function dwhUpdateFailed(business, errorCode) {
  let channel = business ? 'WebsiteBusiness' : 'WebsitePrivate';
  let reportParams = {};
  reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Update Payment Method';
  reportParams.channel = channel;
  reportParams.actionType = 'check card for update';
  reportParams.status = 'Ongoing';
  reportParams.messageText = `Payment Details Failed CG. Code Error: ${errorCode}`;
  report(reportParams);
}

export function dwhSmsComponentTriggered(params) {
  let reportParams = {};
  reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'SettingPaymentEntity';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'SettingPaymentEntity Entrance';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'SettingPaymentEntity Displayed';
  reportParams.customerName = params.customerName || '';
  reportParams.subscriber = params.subscriber || '';
  reportParams.idNumber = params.idNumber || '';
  reportParams.param1 = params.oldCreditCardLast4 || '';
  reportParams.param2 = params.accountsToUpdate || '';
  reportParams.param3 = params.smsPhoneNumber || '';
  reportParams.param4 = params.newPaymentMethodLast4 || '';
  reportParams.param9 = params.subscriberNumber || '';
  reportParams.param10 = getLoginLevel();
  reportParams.banId = params.banId || '';
  reportParams.psId = params.subscriber || '';
  reportParams.email = params.email || '';
  report(reportParams);
}

export function dwhSmsSentSuccessfully(params) {
  let reportParams = {};
  reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'SettingPaymentEntity';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'SettingPaymentEntity Invitation';
  reportParams.status = 'Completed';
  reportParams.messageText = 'SettingPaymentEntity Invitation Sent';
  reportParams.customerName = params.customerName || '';
  reportParams.subscriber = params.subscriber || '';
  reportParams.idNumber = params.idNumber || '';
  reportParams.param1 = params.oldCreditCardLast4 || '';
  reportParams.param2 = params.accountsToUpdate || '';
  reportParams.param3 = params.smsPhoneNumber || '';
  reportParams.param4 = params.newPaymentMethodLast4 || '';
  reportParams.param9 = params.subscriberNumber || '';
  reportParams.param10 = getLoginLevel();
  reportParams.banId = params.banId || '';
  reportParams.psId = params.subscriber || '';
  reportParams.email = params.email || '';
  report(reportParams);
}

export function dwhEntityPaymentEntrance(params) {
  let reportParams = {};
  reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'SettingPaymentEntity';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'Payment Setting Entrance';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Payment Setting Displayed';
  reportParams.customerName = params.customerName || '';
  reportParams.subscriber = params.subscriber || '';
  reportParams.idNumber = params.idNumber || '';
  reportParams.param1 = params.oldCreditCardLast4 || '';
  reportParams.param2 = params.accountsToUpdate || '';
  reportParams.param3 = params.smsPhoneNumber || '';
  reportParams.param4 = params.newPaymentMethodLast4 || '';
  reportParams.param9 = params.subscriberNumber || '';
  reportParams.param10 = getLoginLevel();
  reportParams.banId = params.banId || '';
  reportParams.psId = params.subscriber || '';
  reportParams.email = params.email || '';
  report(reportParams);
}

export function dwhEntityPaymentSuccess(params) {
  let reportParams = {};
  reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'SettingPaymentEntity';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'Payment Update';
  reportParams.status = 'Completed';
  reportParams.messageText = 'Payment Update Success';
  reportParams.customerName = params.customerName || '';
  reportParams.subscriber = params.subscriber || '';
  reportParams.idNumber = params.idNumber || '';
  reportParams.param1 = params.oldCreditCardLast4 || '';
  reportParams.param2 = params.accountsToUpdate || '';
  reportParams.param3 = params.smsPhoneNumber || '';
  reportParams.param4 = params.newPaymentMethodLast4 || '';
  reportParams.param9 = params.subscriberNumber || '';
  reportParams.param10 = getLoginLevel();
  reportParams.banId = params.banId || '';
  reportParams.psId = params.subscriber || '';
  reportParams.email = params.email || '';
  report(reportParams);
}

export function dwhEntityPaymentFailure(params) {
  let reportParams = {};
  reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'SettingPaymentEntity';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'Payment Update';
  reportParams.status = 'Error';
  reportParams.messageText = 'General Error';
  reportParams.customerName = params.customerName || '';
  reportParams.subscriber = params.subscriber || '';
  reportParams.idNumber = params.idNumber || '';
  reportParams.param1 = params.oldCreditCardLast4 || '';
  reportParams.param2 = params.accountsToUpdate || '';
  reportParams.param3 = params.smsPhoneNumber || '';
  reportParams.param4 = params.newPaymentMethodLast4 || '';
  reportParams.param9 = params.subscriberNumber || '';
  reportParams.param10 = getLoginLevel();
  reportParams.banId = params.banId || '';
  reportParams.psId = params.subscriber || '';
  reportParams.email = params.email || '';
  report(reportParams);
}
